import SportsFeedStreamOverview from './SportsFeedStreamOverview'
import SportsFeedStreamSettings from './SportsFeedStreamSettings'

export default Object.freeze({
  type: 'sportsfeedstream',
  title: 'Integrations_SportsFeedStream',
  category: 'Integrations_Sportradar_Category',
  description: 'Integrations_SportsFeedStream_Description',
  image: require('@/img/integrations/sportradar.png'),
  requiresAdmin: false,
  components: {
    overview: SportsFeedStreamOverview,
    settings: SportsFeedStreamSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/sportradar'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportsfeedstream/index.js